import { RECHARGE_ADMIN_URL } from '@flux/shared';

/**
 * Lien « Ouvrir dans Recharge » d'un objet cité par un webhook. Seuls les
 * abonnements et les clients ont une page stable dans l'admin Recharge ; les
 * autres types (`charge`, `address`) n'ont pas de lien.
 */
export function rechargeAdminObjectUrl(
  objectType: string | null,
  objectId: string | null,
): string | null {
  if (objectType === null || objectId === null || objectId === '') {
    return null;
  }
  const id = encodeURIComponent(objectId);
  if (objectType === 'subscription') {
    return `${RECHARGE_ADMIN_URL}/subscriptions/${id}/details`;
  }
  if (objectType === 'customer') {
    return `${RECHARGE_ADMIN_URL}/customers/${id}`;
  }
  return null;
}
